<div class="wizard-step-content">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h3 class="mb-1">
        <i class="fa fa-list text-primary me-2"></i>
        {{ 'eventWizard.classes.title' | translate }}
      </h3>
      <p class="text-muted mb-0">{{ 'eventWizard.classes.subtitle' | translate }}</p>
    </div>
    <app-button
      [variant]="'primary'"
      [label]="'eventWizard.classes.addClass' | translate"
      [iconClass]="'fa fa-plus'"
      [disabled]="!event"
      (clicked)="openAddClassModal()"
    />
  </div>

  @if (!event) {
    <div class="alert alert-warning">
      <i class="fa fa-exclamation-triangle me-2"></i>
      {{ 'eventWizard.classes.completeBasicFirst' | translate }}
    </div>
  } @else {
    <!-- Day Tabs Navigation -->
    @if (eventDays.length > 1) {
      <div class="day-tabs-wrapper mb-4">
        <div class="day-tabs">
          @for (day of eventDays; track day.date.getTime()) {
            <button class="day-tab"
                    [class.active]="selectedDay && isSameDay(selectedDay, day.date)"
                    [class.today]="day.isToday"
                    (click)="selectDay(day)">
              <span class="day-label">{{ day.label }}</span>
              <span class="day-label-short">{{ day.shortLabel }}</span>
              @if (getClassCountForDay(day) > 0) {
                <span class="day-count">{{ getClassCountForDay(day) }}</span>
              }
            </button>
          }
        </div>
      </div>
    }

    @if (filteredClasses.length === 0) {
      <div class="text-center py-10">
        <i class="fa fa-calendar-plus fs-3x text-muted mb-4 d-block opacity-50"></i>
        <h5 class="text-muted mb-2">{{ 'eventWizard.classes.noClassesYet' | translate }}</h5>
        <p class="text-muted mb-4">{{ 'eventWizard.classes.clickAddClass' | translate }}</p>
      </div>
    } @else {
      <div class="table-responsive">
        <table class="table table-row-bordered table-row-dashed gy-4 align-middle fw-bold">
          <thead class="fs-7 text-gray-500 text-uppercase">
            <tr>
              <th class="min-w-200px">{{ 'eventWizard.classes.name' | translate }}</th>
              <th class="min-w-150px">{{ 'eventWizard.classes.startTime' | translate }}</th>
              <th class="min-w-100px">{{ 'eventWizard.classes.price' | translate }}</th>
              <th class="min-w-100px">{{ 'eventWizard.classes.maxRegistrations' | translate }}</th>
              <th class="text-end min-w-100px">{{ 'common.actions' | translate }}</th>
            </tr>
          </thead>
          <tbody class="fs-6">
            @for (class of filteredClasses; track class.event_class_id) {
              <tr>
                <td>
                  <span class="fw-semibold text-gray-800">{{ class.class_name }}</span>
                  @if (class.class_description) {
                    <div class="text-muted fs-7">{{ class.class_description }}</div>
                  }
                </td>
                <td>{{ formatDateTime(class.start_date_time!) }}</td>
                <td>{{ class.price || 0 }} {{ event?.default_currency || class.price_currency || 'NOK' }}</td>
                <td>{{ class.max_num_registrations || ('eventWizard.classes.unlimited' | translate) }}</td>
                <td class="text-end">
                  <div class="d-flex justify-content-end gap-2">
                    <button
                      class="btn btn-sm btn-icon btn-light btn-active-light-primary"
                      (click)="openCopyClassModal(class)"
                      [title]="'manageEvent.classes.copy' | translate"
                    >
                      <i class="fa fa-copy"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-icon btn-light btn-active-light-primary"
                      (click)="openEditClassModal(class)"
                      [title]="'common.edit' | translate"
                    >
                      <i class="fa fa-edit"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-icon btn-light btn-active-light-danger"
                      (click)="deleteClass(class)"
                      [title]="'common.delete' | translate"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    @if (classes.length > 0) {
      <div class="alert alert-light-success border border-success border-dashed mt-4">
        <div class="d-flex align-items-center">
          <i class="fa fa-check-circle text-success fs-2 me-3"></i>
          <div>
            <strong>{{ 'eventWizard.classes.classesAdded' | translate:{ count: classes.length } }}</strong>
            <div class="text-muted">{{ 'eventWizard.classes.continueOrAddMore' | translate }}</div>
          </div>
        </div>
      </div>
    }
  }
</div>
